import {
	SidebarGroup,
	SidebarGroupLabel,
	SidebarMenu,
} from "@/components/ui/sidebar";
import { NavMainItem } from "../Interface/NavBar";
import { CollapsibleNavItem } from "./nav-collapsible-nav-item";
import { SimpleNavItem } from "./nav-items";

export function NavMain({ items }: { items: NavMainItem[] }) {
	return (
		<SidebarGroup>
			<SidebarGroupLabel>Navigation</SidebarGroupLabel>

			<SidebarMenu>
				{items.map((item) => {
					const hasSubItems = item.items && item.items.length > 0;

					if (hasSubItems) {
						return <CollapsibleNavItem key={item.title} item={item} />;
					} else {
						return <SimpleNavItem key={item.title} item={item} />;
					}
				})}
			</SidebarMenu>
		</SidebarGroup>
	);
}
